import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { FiAlertTriangle, FiTrendingUp, FiTrendingDown } from "react-icons/fi";
import { formatPrice } from "../../../../utils/formatPrice";
import { formatPriceWithSymbol } from "../../../../utils/currency";
import "./styles.css";

const ModalDiferencaSaldo = ({
  isOpen,
  onClose,
  onConfirm,
  diferenca,
  saldoAnterior,
  saldoInformado,
  tipo // 'sangria' ou 'suprimento'
}) => {
  const { t } = useTranslation('cashRegister');
  const [loading, setLoading] = useState(false);
  const [motivo, setMotivo] = useState("");

  const isSangria = tipo === 'sangria';
  const valorDiferenca = Math.abs(diferenca);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!motivo.trim()) {
      alert(t('balanceDiff.reasonRequired'));
      return;
    }

    setLoading(true);
    try {
      await onConfirm({
        motivo: motivo.trim(),
        valor: valorDiferenca,
        tipo: tipo
      });
      setMotivo("");
      onClose();
    } catch (error) {
      process.env.REACT_APP_ISDEVELOP === 'true' && console.error('Erro ao processar diferença:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setMotivo("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-diferenca-container">
        <div className="modal-diferenca-header">
          {isSangria ? (
            <FiTrendingDown className="modal-diferenca-icon sangria" />
          ) : (
            <FiTrendingUp className="modal-diferenca-icon suprimento" />
          )}
          <span>
            {isSangria ? t('balanceDiff.titleSangria') : t('balanceDiff.titleSuprimento')}
          </span>
        </div>

        <div className="modal-diferenca-content">
          <div className={`diferenca-alert ${isSangria ? 'warning' : 'info'}`}>
            <FiAlertTriangle className="alert-icon" />
            <div className="alert-content">
              <h4>
                {isSangria
                  ? t('balanceDiff.alertTitleSangria')
                  : t('balanceDiff.alertTitleSuprimento')
                }
              </h4>
              <div className="diferenca-detalhes">
                <p><strong>{t('balanceDiff.previousBalance')}</strong> {formatPriceWithSymbol(saldoAnterior)}</p>
                <p><strong>{t('balanceDiff.currentValue')}</strong> {formatPriceWithSymbol(saldoInformado)}</p>
                <p className={`diferenca-valor ${isSangria ? 'sangria' : 'suprimento'}`}>
                  <strong>{t('balanceDiff.difference')}</strong> {formatPriceWithSymbol(valorDiferenca)}
                </p>
              </div>
            </div>
          </div>

          <div className="diferenca-explicacao">
            <p>
              {isSangria
                ? t('balanceDiff.explanationSangria')
                : t('balanceDiff.explanationSuprimento')
              }
            </p>
            <p><strong>{t('balanceDiff.reasonPrompt')}</strong></p>
          </div>

          <form onSubmit={handleSubmit} className="diferenca-form">
            <div className="form-group">
              <label htmlFor="motivo">{t('balanceDiff.reasonLabel')}</label>
              <textarea
                id="motivo"
                value={motivo}
                onChange={(e) => setMotivo(e.target.value)}
                rows={4}
                placeholder={
                  isSangria
                    ? t('balanceDiff.reasonPlaceholderSangria')
                    : t('balanceDiff.reasonPlaceholderSuprimento')
                }
                maxLength={200}
                required
              />
              <small>{t('balanceDiff.charCount', { current: motivo.length, max: 200 })}</small>
            </div>

            <div className="diferenca-actions">
              <button type="button" onClick={handleCancel} disabled={loading}>
                {t('balanceDiff.cancel')}
              </button>
              <button
                type="submit"
                disabled={loading || !motivo.trim()}
                className={isSangria ? 'btn-sangria' : 'btn-suprimento'}
              >
                {loading ? t('balanceDiff.processing') : (isSangria ? t('balanceDiff.confirmSangria') : t('balanceDiff.confirmSuprimento'))}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ModalDiferencaSaldo;
